/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CertRosetteAltIcon24Solid = forwardRef('CertRosetteAltIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 1.5a7.5 7.5 0 0 0-5 13.09v7.107a1.25 1.25 0 0 0 1.931 1.048L12 20.75l3.069 1.995A1.25 1.25 0 0 0 17 21.697V14.59A7.5 7.5 0 0 0 12 1.5ZM7.5 9a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Z" })));
});
